import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['fileInput', 'submitButton']

  connect() {
    this.checkFile()
  }

  checkFile() {
    const hasFile = this.fileInputTarget.files.length > 0
    this.submitButtonTarget.disabled = !hasFile
  }
}
